// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// Redux
import { store } from './app/store';
import { Provider } from 'react-redux';

// i18n (важно импортировать ДО рендера)
import './i18n';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import AppShell from './app/appShell';
import Loader from './components/loader/loader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loader />}>
          <AppShell>
            <App />
          </AppShell>
        </Suspense>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
